import { Component, OnInit, Input, OnChanges } from '@angular/core';
import {GoogleCharts} from 'google-charts';

@Component({
  selector: 'app-weekly-chart',
  templateUrl: './weekly-chart.component.html',
  styleUrls: ['./weekly-chart.component.less']
})
export class WeeklyChartComponent implements OnInit, OnChanges {
  @Input() chartData;
  @Input() publicationType;

  constructor() { }

  ngOnInit(): void {

  }

  ngOnChanges(changes) {
    if (changes.chartData && changes.chartData.currentValue) {
      this.googleCharts();
    }
    if (changes.publicationType && changes.publicationType.currentValue) {
      this.googleCharts();
    }
  }

  googleCharts() {
    GoogleCharts.load(() => {
      const data = this.publicationType === 1 ? this.chartData.weeks : this.chartData.months;
      const publications = GoogleCharts.api.visualization.arrayToDataTable(data);
      const weekly = document.getElementById('weeklyBars');
      const columnChart = new GoogleCharts.api.visualization.ColumnChart(weekly);

      const options = {
        width: 190,
        height: 150,
        colors: ['#ff9800'],
        chartArea: {
          width: '95%',
          height: '90%'
        }
      };

      columnChart.draw(publications, options);
      }, {
        packages: ['corechart', 'geochart'],
        mapsApiKey: 'AIzaSyCzosbpGRwQcbxv2gGcvavVYJbiI2s0i00'
  });
  }

}
